import { GoogleAdMob } from '@apps-in-toss/web-framework';
import { isInTossApp } from './env';

// 토스 콘솔에서 발급받는 ID — 심사 전 환경 변수 / 콘솔 등록값으로 교체
const AD_GROUP_REWARD = import.meta.env.VITE_AD_GROUP_REWARD ?? 'AD_GROUP_REWARD_PLACEHOLDER';

export type AdResult = 'rewarded' | 'dismissed' | 'failed';

let prepared: string | null = null;
let cleanupLoad: (() => void) | null = null;

// 진입 시 1회 호출 — 광고 미리 로드
export function preloadRewardAd(): void {
  if (!isInTossApp()) return;
  if (!GoogleAdMob.loadAppsInTossAdMob.isSupported?.()) return;

  cleanupLoad?.();
  cleanupLoad = GoogleAdMob.loadAppsInTossAdMob({
    options: { adGroupId: AD_GROUP_REWARD },
    onEvent: (event) => {
      if (event.type === 'loaded') prepared = AD_GROUP_REWARD;
    },
    onError: () => { prepared = null; },
  });
}

// 사용자 액션 시 광고 노출. 보상 획득 / 닫힘 / 실패 결과 반환.
// 토스 환경 외에서는 즉시 'rewarded' 반환 (Mock — 개발 편의).
export function showRewardAd(): Promise<AdResult> {
  if (!isInTossApp()) return Promise.resolve('rewarded');
  if (!GoogleAdMob.showAppsInTossAdMob.isSupported?.()) return Promise.resolve('failed');

  return new Promise<AdResult>((resolve) => {
    let earned = false;
    let resolved = false;
    const finish = (r: AdResult) => {
      if (resolved) return;
      resolved = true;
      resolve(r);
    };

    GoogleAdMob.showAppsInTossAdMob({
      options: { adGroupId: AD_GROUP_REWARD },
      onEvent: (event) => {
        switch (event.type) {
          case 'userEarnedReward':
            earned = true;
            break;
          case 'dismissed':
            finish(earned ? 'rewarded' : 'dismissed');
            // 닫힌 직후 다음 광고 미리 로드
            preloadRewardAd();
            break;
          case 'failedToShow':
            finish('failed');
            break;
        }
      },
      onError: () => finish('failed'),
    });
  });
}

// 광고 준비됐는지 — UI에서 버튼 비활성화 등에 활용
export function isAdReady(): boolean {
  if (!isInTossApp()) return true;
  return prepared === AD_GROUP_REWARD;
}
